import { interval } from 'rxjs';

const timeMs = 333;
const interval$ = interval(timeMs);

export default interval$;
